var INPUT_SHAPE = {
  LINE: 'line',
  BOX: 'box'
};
var INPUT_AREA_TEXT_ALIGN = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center'
};
var INPUT_FORMAT_TYPE = {
  NONE: 'none',
  NUMBER: 'number',
  COMMA_ADDED_NUMBER: 'commaAddedNumber'
};
var INPUT_BOX_SIZE = {
  LARGE: 'large',
  MEDIUM: 'medium'
};

export { INPUT_AREA_TEXT_ALIGN, INPUT_BOX_SIZE, INPUT_FORMAT_TYPE, INPUT_SHAPE };
